import { render } from "./CreateCompanyModal.vue?vue&type=template&id=2d0de9ca"
import script from "./CreateCompanyModal.vue?vue&type=script&lang=js"
export * from "./CreateCompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__